import { render, staticRenderFns } from "./GamesBlockSimple.vue?vue&type=template&id=a898ee48&scoped=true&"
import script from "./GamesBlockSimple.vue?vue&type=script&lang=js&"
export * from "./GamesBlockSimple.vue?vue&type=script&lang=js&"
import style0 from "./GamesBlockSimple.vue?vue&type=style&index=0&id=a898ee48&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a898ee48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a898ee48')) {
      api.createRecord('a898ee48', component.options)
    } else {
      api.reload('a898ee48', component.options)
    }
    module.hot.accept("./GamesBlockSimple.vue?vue&type=template&id=a898ee48&scoped=true&", function () {
      api.rerender('a898ee48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/games/GamesBlockSimple.vue"
export default component.exports